import React, { useEffect, useRef } from "react";
import { config } from "./config/main";
import { APP_ACTIONS } from "./utils/constants/appActions";
import { AppContext } from "./AppContext";
import {
  GetAllPreloadDataListThunk,
  getLoggedInUserDetails,
  getPrepaidAccountDetails,
  updateAuthUserLogo,
  updateAuthUserLogoHeight,
} from "./store/slice/common-slice";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { updateGlobalListFlag } from "./store/slice/common-slice";
import { unwrapResult } from "@reduxjs/toolkit";
import { searchObjFromArrayOfObjs } from "./utils/InputValidations";

import { updateAuthUserTheme } from "./store/slice/common-slice";
import {
  updateReportingFiltersDate,
  updateReportingFiltersTimezone,
} from "./store/slice/report-slice";
import { getAllEligibleFutureTargetingCampaigns } from "./store/slice/campaign-slice";
import moment from "moment";
import { getTodayDateBasedOnTimeZone } from "./utils/utils";
import { ASSET_IMAGES } from "./utils/constants/paths";
function init(initialValue) {
  return {
    customizerVisibility: initialValue.customizerVisibility,
    containerStyle: initialValue.containerStyle,
    rebuildRoutes: true,
  };
}

function appReducer(state, action) {
  switch (action.type) {
    case APP_ACTIONS.SET_CUSTOMIZER_VISIBILITY:
      return {
        ...state,
        customizerVisibility: action.payload,
      };

    case APP_ACTIONS.SET_CONTAINER_STYLE:
      return {
        ...state,
        containerStyle: action.payload,
      };

    case APP_ACTIONS.SET_APP:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}

const AppProvider = ({ children }) => {
  const [app, setApp] = React.useReducer(
    appReducer,
    {
      customizerVisibility: false,
      containerStyle: config.containerStyle,
    },
    init
  );

  const setCustomizerVisibility = React.useCallback(
    (value) => {
      setApp({ type: APP_ACTIONS.SET_CUSTOMIZER_VISIBILITY, payload: value });
    },
    [setApp]
  );

  const setContainerStyle = React.useCallback(
    (containerStyle) => {
      setApp({
        type: APP_ACTIONS.SET_CONTAINER_STYLE,
        payload: containerStyle,
      });
    },
    [setApp]
  );

  const setAppState = React.useCallback(
    (stateObject) => {
      setApp({ type: APP_ACTIONS.SET_APP, payload: stateObject });
    },
    [setApp]
  );

  const rebuildRoutes = React.useCallback((value) => {}, [setApp]);

  const contextValue = React.useMemo(
    () => ({
      ...app,
      setCustomizerVisibility,
      setContainerStyle,
      setAppState,
    }),
    [app]
  );
  const { globalListFlag } = useSelector((state) => state.CommonReducer);

  //Get Logged In User Info and Store in Slice
  //Then Based on loggedin user - load other data like accounts etc.

  const access_token = localStorage.getItem("access_token");
  const dispatch = useDispatch();
  //console.log("Access Token:", access_token);
  useEffect(() => {
    if (access_token != null && access_token != "") {
      dispatch(getLoggedInUserDetails())
        .then(unwrapResult)
        .then((res) => {
          if (res.data.success == true) {
            let userData = res.data.user_data;
            let userTimeZone =
              userData?.report_timezone_country != "" &&
              userData?.report_timezone_country != null
                ? userData?.report_timezone_country
                : "UTC";
            dispatch(
              updateReportingFiltersTimezone({ timezone: userTimeZone })
            );
            dispatch(
              updateReportingFiltersDate({
                start_date: getTodayDateBasedOnTimeZone(userTimeZone),
                end_date: getTodayDateBasedOnTimeZone(userTimeZone),
              })
            );
            dispatch(GetAllPreloadDataListThunk({ user_data: userData }))
              .then(unwrapResult)
              .then((res) => {
                if (res.data?.results.length > 0) {
                  let companiesList = res.data.results[0];
                  let accountsList = res.data.results[1];
                  if (userData.is_sys_admin == "1") {
                    dispatch(updateAuthUserLogo(ASSET_IMAGES + "/newlogo.png"));
                  } else if (companiesList.length > 0) {
                    let companyTheme = companiesList[0].theme;
                    let companyLogo = companiesList[0].logo_url;
                    let companyLogoHeight = companiesList[0].logo_height;
                    if (
                      companyTheme != "" &&
                      companyTheme != undefined &&
                      companyTheme != "undefined"
                    ) {
                      let themesList = res.data.results[7];
                      let themeDetails = searchObjFromArrayOfObjs(themesList, {
                        value: companyTheme,
                      });
                      if (themeDetails != "") {
                        dispatch(updateAuthUserTheme(themeDetails));
                      }
                    }

                    //If only one account is there and it has logo url then use that logo instead of company logo
                    if (
                      accountsList.length == 1 &&
                      accountsList[0].logo_url != "" &&
                      accountsList[0].logo_url != null &&
                      accountsList[0].logo_url != undefined
                    ) {
                      dispatch(updateAuthUserLogo(accountsList[0].logo_url));
                    } else if (
                      companyLogo != "" &&
                      companyLogo != undefined &&
                      companyLogo != "undefined"
                    ) {
                      dispatch(updateAuthUserLogo(companyLogo));
                    } else {
                      dispatch(
                        updateAuthUserLogo(ASSET_IMAGES + "/newlogo.png")
                      );
                    }
                    if (
                      companyLogoHeight != "" &&
                      companyLogoHeight != undefined &&
                      companyLogoHeight != "undefined"
                    ) {
                      dispatch(updateAuthUserLogoHeight(companyLogoHeight));
                    }

                  }

                  if (res.data.results[3].length > 0) {
                    dispatch(
                      getAllEligibleFutureTargetingCampaigns({
                        advertiserList: res.data.results[3],
                      })
                    );
                  }
                } else {
                }
              });
            if (
              userData.is_sys_admin != "1" &&
              userData.user_assoc_accounts.hasOwnProperty("advertiser") &&
              userData.user_assoc_accounts["advertiser"].length > 0
            ) {
              dispatch(
                getPrepaidAccountDetails({
                  accounts: userData.user_assoc_accounts["advertiser"],
                })
              );
            }
          } else {
            //ToastRef.current.showSweetAlerts("error", res.data.message);
          }
        });
      //dispatch(GetAllPreloadDataListThunk());
    } else {
      dispatch(updateGlobalListFlag({ globalListFlag: true }));
    }
  }, [access_token]);

  return (
    <>
      {globalListFlag == false && (
        <Box sx={{ margin: "auto" }}>
          <Box className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle className="loader-path" cx="50" cy="50" r="20"></circle>
            </svg>
          </Box>
        </Box>
      )}
      {globalListFlag == true && (
        <AppContext.Provider value={contextValue}>
          {children}
        </AppContext.Provider>
      )}
    </>
  );
};

export default AppProvider;
